module.exports = __webpack_public_path__ + "img/5_澳门1(1).aafcfe3b.jpg";